import * as React from 'react';
import * as I18n from 'i18n-js';
import AlertBox from '@reverbdotcom/commons/dist/components/alert_box';

interface IState {
  showHint: boolean;
}

interface IProps {
  streetAddress: string;
}

export default class StreetAddressFormatHint extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      showHint: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.checkStreetAddressFormatting(nextProps.streetAddress);
  }

  checkStreetAddressFormatting(rawText) {
    const inputText = rawText.trim();

    if (this.inputHasOneWord(inputText) && this.inputHasNoNumbers(inputText)) {
      this.setState({ showHint: true });
    } else {
      this.setState({ showHint: false });
    }
  }

  inputHasOneWord(text) {
    const singleWordRegex = new RegExp(/^[^\s]*$/);
    return singleWordRegex.test(text);
  }

  inputHasNoNumbers(text) {
    const noNumberRegex = new RegExp(/^[^0-9]+$/);
    return noNumberRegex.test(text);
  }

  display() {
    return {
      display: this.state.showHint ? 'block' : 'none',
    };
  }

  render() {
    if (!this.state.showHint) {
      return null;
    }

    return (
      <div
        ref="streetAddressFormatHint"
        style={this.display()}
        className="mb-2"
      >
        <AlertBox small>
          {I18n.t('discovery.bundledCheckout.streetAddressFormatHint.hint')}
        </AlertBox>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/shared/addresses/street_address_format_hint.tsx